import { apiSlice } from "../api/apiSlice";

export const teamsApi = apiSlice.injectEndpoints({
    tagTypes: ["Teams"],
    endpoints: (builder) => ({
        getTeams: builder.query({
            query: () => ({
                url: "teams"
            }),
            providesTags: ["Teams"]
        }),

        addTeam: builder.mutation({
            query: ({ data }) => ({
                url: "/teams",
                method: "POST",
                body: data
            }),
            invalidatesTags: ["Teams"]
        }),

        editTeam: builder.mutation({
            query: ({ id, data }) => ({
                url: `/teams/${id}`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["Teams"]
        })
    })  
});

export const {
    useGetTeamsQuery,
    useAddTeamMutation,
    useEditTeamMutation
} = teamsApi;
